const Dlt = {
  symbol: 'dlt',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-.193-23.042a.244.244 0 0 1 .222-.143c.094 0 .18.057.22.145l6.29 13.695a.877.877 0 0 0 .794.516h.084a.57.57 0 0 0 .548-.423.955.955 0 0 0-.058-.666L16.614 6.83a.497.497 0 0 0-.135-.171.692.692 0 0 0-.892.008 1.245 1.245 0 0 0-.313.411l-7.19 15.148a.874.874 0 0 0 .29 1.09l.056.04c.138.094.3.144.466.144h10.752a.96.96 0 0 0 .835-.495.641.641 0 0 0 .031-.56l-.01-.025a.732.732 0 0 0-.674-.455H9.713z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" fill="#f4ae95" r="16"/><path d="M15.807 8.958L9.713 21.965H19.83c.293 0 .558.18.673.455l.011.025a.641.641 0 0 1-.031.56.96.96 0 0 1-.835.495H8.896a.826.826 0 0 1-.466-.145l-.056-.038a.874.874 0 0 1-.29-1.09l7.19-15.149c.075-.158.182-.298.313-.41a.692.692 0 0 1 .892-.01.497.497 0 0 1 .135.172l7.293 15.252c.1.207.12.444.058.666a.57.57 0 0 1-.548.423h-.084a.877.877 0 0 1-.794-.516L16.249 8.96a.244.244 0 0 0-.22-.145.244.244 0 0 0-.222.143z" fill="#fff"/></g>`;
  }
};
export default Dlt;
